import Myservicestable from '$pages/serviceuser/Myservices/Myservicestable'
import ServicesPage from '$components/Services/ServicesTabs'

const Myservices = () => (
  <ServicesPage TableComponent={Myservicestable} title={'My Services'} />
)

export default Myservices
